export const toRGBAString = (color: any) =>
  color ? `rgba(${color.r},${color.g},${color.b},${color.a})` : undefined;
